import { render, staticRenderFns } from "./EducationalGroupInfo.vue?vue&type=template&id=d73a6dd0&"
import script from "./EducationalGroupInfo.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports